var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0001 10.8V8.40002C6.0001 6.80873 6.63224 5.2826 7.75746 4.15738C8.88268 3.03217 10.4088 2.40002 12.0001 2.40002C13.5914 2.40002 15.1175 3.03217 16.2427 4.15738C17.368 5.2826 18.0001 6.80873 18.0001 8.40002V10.8C18.6366 10.8 19.2471 11.0529 19.6972 11.503C20.1472 11.9531 20.4001 12.5635 20.4001 13.2V19.2C20.4001 19.8365 20.1472 20.447 19.6972 20.8971C19.2471 21.3472 18.6366 21.6 18.0001 21.6H6.0001C5.36358 21.6 4.75313 21.3472 4.30304 20.8971C3.85295 20.447 3.6001 19.8365 3.6001 19.2V13.2C3.6001 12.5635 3.85295 11.9531 4.30304 11.503C4.75313 11.0529 5.36358 10.8 6.0001 10.8ZM15.6001 8.40002V10.8H8.4001V8.40002C8.4001 7.44524 8.77938 6.52957 9.45451 5.85444C10.1296 5.17931 11.0453 4.80002 12.0001 4.80002C12.9549 4.80002 13.8706 5.17931 14.5457 5.85444C15.2208 6.52957 15.6001 7.44524 15.6001 8.40002Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.3b5045da2a9da2ca11e397b1d00f8846.svg";
export { ForwardRef as ReactComponent };